import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom, Provider, provideZoneChangeDetection } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MSAL_INSTANCE, MsalBroadcastService, MsalService } from '@azure/msal-angular';

import { appRoutes } from './app.routes';
import { azureAdApiInterceptor } from './core/auth/azure-ad-api.interceptor';
import { isAzureAdEnabled } from './core/auth/azure-ad-env';
import { authInterceptor } from './core/auth/auth.interceptor';
import { AuthService } from './core/auth/auth.service';
import { msalAppInitializer } from './core/auth/msal-app.initializer';
import { createMsalInstance } from './core/auth/msal-auth.config';
import { httpGlobalErrorSnackInterceptor } from './core/http/http-global-error-snackbar.interceptor';

const httpInterceptors = isAzureAdEnabled()
  ? [httpGlobalErrorSnackInterceptor, azureAdApiInterceptor, authInterceptor]
  : [httpGlobalErrorSnackInterceptor, authInterceptor];

const msalProviders: Provider[] = isAzureAdEnabled()
  ? [
      { provide: MSAL_INSTANCE, useFactory: createMsalInstance },
      MsalService,
      MsalBroadcastService,
      {
        provide: APP_INITIALIZER,
        multi: true,
        useFactory: msalAppInitializer,
        deps: [MsalService, AuthService]
      }
    ]
  : [];

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    importProvidersFrom(MatSnackBarModule),
    provideHttpClient(withInterceptors(httpInterceptors)),
    provideAnimations(),
    provideRouter(appRoutes, withComponentInputBinding(), withInMemoryScrolling({ scrollPositionRestoration: 'enabled' })),
    provideCharts(withDefaultRegisterables()),
    provideNativeDateAdapter(),
    ...msalProviders
  ]
};

